import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-[50vh] flex items-center justify-center p-8" data-testid="error-boundary-fallback">
          <div className="max-w-md text-center">
            <div className="text-sm uppercase tracking-widest font-bold text-[#E05A47]">Something went wrong</div>
            <p className="mt-3 text-sm text-muted-foreground">
              This section hit an unexpected error. The rest of the platform is unaffected.
            </p>
            <button
              data-testid="error-boundary-reload"
              onClick={() => { this.setState({ error: null }); window.location.reload(); }}
              className="mt-5 text-xs uppercase tracking-widest font-bold border border-[#0A251D] px-5 py-2.5 rounded-full hover:bg-[#0A251D] hover:text-white transition-colors duration-150"
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
